

function parseHintsFromLocation() {
  let hashParams = window.location.hash.substring(1);
  let searchParams = window.location.search.substring(1);
  let hints = "";
  if (hashParams && searchParams) {
    hints = hashParams + '&' + searchParams;
  } else if (hashParams) {
    hints = hashParams;
  } else {
    hints = searchParams;
  }
  hints = encodeURI(hints);
  return [parseHints(hints), hints];
}

function parseHints(hints) {
  let paramsArr = hints.split('&');
  return paramsArr.reduce((params, part) => {
    let [key, value] = part.split('=');
    if (key) {
      if (!value) {
        value = true;
      }
      params[key] = value;
    }
    return params;
  }, {});
}

function deleteHintParam(name) {
  // Extract the named param from the HINTS_STR string
  let params = HINTS_STR.split('&');
  let copyParams = [];
  for (const param of params) {
    if (!param.startsWith(name + '=')) {
      copyParams.push(param);
    }
  }
  HINTS_STR = copyParams.join('&');
}

let [HINTS, HINTS_STR] = parseHintsFromLocation();

export {HINTS, HINTS_STR, deleteHintParam };